/* DESKIES — Main JS */
(function(){

  // ── CURSOR
  var cur = document.getElementById('dk-cursor');
  var ring = document.getElementById('dk-cursor-ring');
  var mx=0,my=0,rx=0,ry=0;

  document.addEventListener('mousemove',function(e){ mx=e.clientX; my=e.clientY; if(cur){cur.style.left=mx+'px';cur.style.top=my+'px';} });
  function animRing(){ rx+=(mx-rx)*.12; ry+=(my-ry)*.12; if(ring){ring.style.left=rx+'px';ring.style.top=ry+'px';} requestAnimationFrame(animRing); }
  animRing();

  document.querySelectorAll('a,button,.dk-card').forEach(function(el){
    el.addEventListener('mouseenter',function(){ if(cur)cur.classList.add('active'); if(ring)ring.classList.add('active'); });
    el.addEventListener('mouseleave',function(){ if(cur)cur.classList.remove('active'); if(ring)ring.classList.remove('active'); });
  });

  // ── EMBERS — slow drifting motes of brass light, no glyphs
  var canvas = document.getElementById('dk-particles');
  if(canvas){
    var ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    window.addEventListener('resize',function(){ canvas.width=window.innerWidth; canvas.height=window.innerHeight; });

    var particles = [];
    for(var i=0;i<36;i++){
      particles.push({
        x: Math.random()*canvas.width,
        y: Math.random()*canvas.height,
        size: Math.random()*1.6+.6,
        vx: (Math.random()-.5)*.12,
        vy: -Math.random()*.18-.03,
        a: Math.random()*.35+.08,
        color: ['182,146,79','217,185,120','138,44,63'][Math.floor(Math.random()*3)]
      });
    }

    function drawParticles(){
      ctx.clearRect(0,0,canvas.width,canvas.height);
      particles.forEach(function(p){
        p.x+=p.vx; p.y+=p.vy;
        if(p.y<-10){ p.y=canvas.height+10; p.x=Math.random()*canvas.width; }
        if(p.x<-10)p.x=canvas.width+10; if(p.x>canvas.width+10)p.x=-10;
        ctx.globalAlpha=p.a;
        ctx.beginPath(); ctx.arc(p.x,p.y,p.size,0,Math.PI*2);
        ctx.fillStyle='rgba('+p.color+',1)'; ctx.fill();
        ctx.globalAlpha=1;
      });
      requestAnimationFrame(drawParticles);
    }
    drawParticles();
  }

  // ── SCROLL REVEAL
  var obs = new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting)e.target.classList.add('visible'); }); },{threshold:.1});
  document.querySelectorAll('.reveal').forEach(function(el){obs.observe(el);});

  // ── STICKY HEADER
  var header = document.getElementById('dk-header');
  window.addEventListener('scroll',function(){ if(header)header.classList.toggle('scrolled',window.scrollY>20); });

  // ── AJAX CART
  document.querySelectorAll('.add-to-cart-btn').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var id=this.dataset.variantId; if(!id)return;
      var b=this; b.textContent='...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
        .then(function(r){return r.json();}).then(function(){
          b.textContent='✓'; setTimeout(function(){b.textContent='+';},1500);
          fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
            var c=document.getElementById('cart-count'); if(c)c.textContent=cart.item_count;
          });
        }).catch(function(){b.textContent='+';});
    });
  });

})();
